import React from "react";
import {styled} from "@mui/material/styles";
import {COLOR_WHITE} from "@/themes/colors.jsx";


export default function ContainerBox({children, ...props}) {
    return (
        <Container {...props}>
            {children}
        </Container>
    );
}

const Container = styled('div')({
    padding: '12px',
    borderRadius: '15px',
    boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.08)',
    backgroundColor: COLOR_WHITE,
});
